import React, { useEffect, useState } from "react";
import { db } from "../Firebase/firebase-config";
import { ref, onValue, push, set } from "firebase/database";
import { useGetCurrentUserId } from "../hooks/useGetCurrentUserId";
import { Truck } from "lucide-react";
import { Info } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./ClientCreateRequest.css"
import toast from "react-hot-toast";
import { useNotifications } from "./transportNotifications";

const ClientCreateRequest = () => {
  const navigate = useNavigate();
  const { sendNotification } = useNotifications();
  const { userId: currentClientId } = useGetCurrentUserId();
  const [transporters, setTransporters] = useState([]);
  const [formData, setFormData] = useState({
    transporterName: "",
    transporterPhone: "",
    fromAddress: "",
    toAddress: "",
    quantity: "",
   quantityUnit: "Bags",
    addToRoutes: false,
  });
  const [loading, setLoading] = useState(false);
  const [clientName, setClientName] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [selectedTransporterData, setSelectedTransporterData] = useState(null);
  const [showTransporterDetails, setShowTransporterDetails] = useState(false);

  // Fetch current client name
  useEffect(() => {
    if (!currentClientId) return;
    const clientRef = ref(db, `profileDashboard/${currentClientId}`);
    const unsubscribe = onValue(clientRef, (snapshot) => {
      if (snapshot.exists()) {
        setClientName(snapshot.val().company_name || "Client");
      }
    });
    return () => unsubscribe();
  }, [currentClientId]);;
  // Fetch transporters
  useEffect(() => {
    if (!currentClientId) {
      setTransporters([]);
      return;
    }

    const transportRef = ref(db, "transporter-profile");

    const unsubscribe = onValue(transportRef, (snapshot) => {
      const data = snapshot.val();

      if (!data) {
        setTransporters([]);
        return;
      }

      const list = Object.keys(data)
        .filter((key) => {
          return (
            data[key]?.assignedClients &&
            data[key].assignedClients[currentClientId] === true
          );
        })
        .map((key) => ({
          id: key,
          company: data[key]?.company || data[key]?.contactPerson || "",
          phone: data[key]?.phone || "",
        }));
      setTransporters(list);
    });

    return () => unsubscribe();
  }, [currentClientId]);


  // Fetch current client name
  useEffect(() => {
    if (!currentClientId) return;
    const clientRef = ref(db, `profileDashboard/${currentClientId}`);
    const unsubscribe = onValue(clientRef, (snapshot) => {
      if (snapshot.exists()) {
        setClientName(snapshot.val().company_name || "Client");
      }
    });
    return () => unsubscribe();
  }, [currentClientId]);

  const fetchTransporterDetails = async () => {
    if (!formData.transporterId) return;

    const transporterRef = ref(db, `transporter-profile/${formData.transporterId}`);

    onValue(transporterRef, (snapshot) => {
      if (snapshot.exists()) {
        setSelectedTransporterData(snapshot.val());
        setShowTransporterDetails(true);
      } else {
        toast.error("No transporter data found");
      }
    }, { onlyOnce: true });
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleTransporterSelect = (value) => {
    const selected = transporters.find((item) => item.company === value);
    setFormData((prev) => ({
      ...prev,
      transporterName: value,
      transporterPhone: selected?.phone || "",
    }));
  };

  const submitOrder = async () => {
    if (!currentClientId) {
      toast.error("Please login first");
      return;
    }
      const qty = Number(formData.quantity);
     if (!qty || qty <= 25) {
    return  toast.error("Enter valid quantity");
  }

  if (qty > 50000) {
    return  toast.error("Maximum allowed quantity is 50,000");
  }
    if (!formData.transporterName || !formData.fromAddress || !formData.toAddress || !formData.quantity ||  !formData.quantityUnit) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      const selectedTransporter = transporters.find((item) => item.company === formData.transporterName);

      if (!selectedTransporter?.id) {
        toast.error("Please select a valid transporter");
        return;
      }

      const requestRef = push(ref(db, `transport_requests/${selectedTransporter.id}`));

      await set(requestRef, {
        clientId: currentClientId,
        clientName: clientName,
        transporterId: selectedTransporter.id,
        transporterName: formData.transporterName,
        transporterPhone: formData.transporterPhone,
        from: formData.fromAddress,
        to: formData.toAddress,
        quantity: formData.quantity,
        quantityUnit: formData.quantityUnit,
        createdAt: Date.now(),
        status: "waiting for response",
      });

      if (formData.addToRoutes) {
        const routeRef = push(ref(db, "transport-routes"));
        await set(routeRef, {
          from: formData.fromAddress,
          to: formData.toAddress,
          createdAt: Date.now(),
        });
      }

      // Send Notification to Transporter
      await sendNotification({
        targetUserId: formData.transporterId,
        pageTitle: "New Load Request",
        title: "New Transport Request",
       message: `${clientName} requested to transport order for ${formData.quantity} ${formData.quantityUnit} from ${formData.fromAddress} to ${formData.toAddress}.`,
        seen: false,
        category: "request",
        isSupplier: true,
      });
      toast.success("Transport request created successfully!");
      // Reset form
      setFormData({
        transporterName: "",
        transporterPhone: "",
        fromAddress: "",
        toAddress: "",
        quantity: "",
        quantityUnit: "Bags",
        addToRoutes: false,
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to create request");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="ccr-wrapper">
      <div className="ccr-card">

        {/* HEADER WRAPPER */}
        <div className="ccr-header">

          {/* TOP BAR */}
          <div className="ccr-topbar">
            <button className="ccr-back-btn" onClick={() => navigate("/dashboard/transport")}>
              <ArrowLeft size={18} />
              Back
            </button>

            <button
              className="ccr-info-btn"
              onClick={() => setShowInfo(true)}
            >
              <Info size={18} />
            </button>
          </div>

          {/* CENTER TITLE */}
          <div className="ccr-title-center">
            <div className="ccr-icon">
              <Truck size={28} />
            </div>
            <div>
              <h2>Create Load Request</h2>
              <p>Send transport request to transporter</p>
            </div>
          </div>

        </div>

        {showInfo && (
          <div className="ccr-info-overlay">
            <div className="ccr-info-modal">
              <button
                className="ccr-info-close"
                onClick={() => setShowInfo(false)}
              >
                ✕
              </button>

              <h3>How this works</h3>

              <ul>
                <li>Select a transporter from list</li>
                <li>Enter pickup & delivery location</li>
                <li>Add quantity and unit</li>
                <li>Click "Create Request"</li>
                <li>Transporter will send quotation</li>
                <li>You can now check your quote request to view the quotation</li>
              </ul>
            </div>
          </div>
        )}

        {/* TRANSPORTER */}
        <div className="ccr-group">
          <label>Transporter</label>
          <select
            value={formData.transporterId || ""}
            onChange={(e) => {
              const selected = transporters.find(t => t.id === e.target.value);
              setFormData(prev => ({
                ...prev,
                transporterId: selected?.id,
                transporterName: selected?.company,
                transporterPhone: selected?.phone
              }));
            }}
          >
            <option value="">Select transporter</option>
            {transporters.map((t) => (
              <option key={t.id} value={t.id}>
                {t.company} ({t.phone})
              </option>
            ))}
          </select>
        
        </div>
        {showTransporterDetails && selectedTransporterData && (
          <div className="ccr-info-overlay">
            <div className="ccr-info-modal">
              <button
                className="ccr-info-close"
                onClick={() => setShowTransporterDetails(false)}
              >
                ✕
              </button>

              <h3>Transporter Details</h3>

              {selectedTransporterData.contactPerson && (
                <p><strong>Contact Person:</strong> {selectedTransporterData.contactPerson}</p>
              )}

              {selectedTransporterData.phone && (
                <p><strong>Phone:</strong> {selectedTransporterData.phone}</p>
              )}

              {selectedTransporterData.email && (
                <p><strong>Email:</strong> {selectedTransporterData.email}</p>
              )}

              {selectedTransporterData.state && (
                <p><strong>State:</strong> {selectedTransporterData.state}</p>
              )}

              {selectedTransporterData.gst && (
                <p><strong>GST:</strong> {selectedTransporterData.gst}</p>
              )}

              {selectedTransporterData.pan && (
                <p><strong>PAN:</strong> {selectedTransporterData.pan}</p>
              )}
              <div>
                <strong>Trucks:</strong>

                <div className="ccr-truck-list">
                  {selectedTransporterData.trucks
                    ? Object.entries(selectedTransporterData.trucks).map(([key, truck]) => (
                      <div key={key} className="ccr-truck-card">

                        <p><strong>Truck No:</strong> {truck?.truckNumber || "-"}</p>
                        <p><strong>Route:</strong> {truck?.from} → {truck?.to}</p>
                        <p><strong>Primary No:</strong> {truck?.primaryNumber || "-"}</p>
                        <p><strong>Secondary No:</strong> {truck?.secondaryNumber || "-"}</p>

                      </div>
                    ))
                    : <p>-</p>}
                </div>
              </div>

            </div>
          </div>
        )}
        {/* ROUTES */}
        <div className="ccr-row">
          <div className="ccr-group">
            <label>Pickup Location</label>
            <input
              type="text"
              placeholder="Pickup location"
              value={formData.fromAddress}
              onChange={(e) => handleChange("fromAddress", e.target.value)}
            />
          </div>

          <div className="ccr-group">
            <label>Delivery Location</label>
            <input
              type="text"
              placeholder="Delivery location"
              value={formData.toAddress}
              onChange={(e) => handleChange("toAddress", e.target.value)}
            />
          </div>
        </div>

        {/* QUANTITY */}
        <div className="ccr-row">
          <div className="ccr-group">
  <label>Unit</label>

  <div className="unit-toggle">
    <button
      type="button"
      className={formData.quantityUnit === "Bags" ? "active" : ""}
      onClick={() => handleChange("quantityUnit", "Bags")}
    >
      Bags
    </button>

    <button
      type="button"
      className={formData.quantityUnit === "MT" ? "active" : ""}
      onClick={() => handleChange("quantityUnit", "MT")}
    >
      MT
    </button>
  </div>
</div>
          <div className="ccr-group">
            <label>Quantity</label>
            <input
              type="number"
              placeholder="Enter quantity"
              value={formData.quantity}
              onWheel={(e) => { e.target.blur() }}
              min={250}
              max={50000}
              onChange={(e) => handleChange("quantity", e.target.value)}
            />
          </div>

        
        </div>

        {/* SUBMIT */}
        <button className="ccr-submit" onClick={submitOrder} disabled={loading}>
          {loading ? "Creating..." : "Create Request"}
        </button>

      </div>
    </div>
  );
}

export default ClientCreateRequest;